import { useEffect, useRef, useState } from "react";
import { IQuestion } from "../types";
import { useAnalytics } from "../firebase/firebase";

interface ScrollIntoViewEffectProps {
    setCursor: (q: IQuestion) => void;
    data: IQuestion[];
}

export const ScrollIntoViewEffect = (props: ScrollIntoViewEffectProps) => {
    const { track } = useAnalytics()
    const ref = useRef(null);
    const hasBeenOutOfView = useRef(false);
    const hasPosted = useRef(true);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) {
                    hasBeenOutOfView.current = true;
                    hasPosted.current = false;
                }
                else if (hasBeenOutOfView.current) {
                    // console.log(props.data);
                    let cursor = props.data[props.data.length - 1];
                    if (cursor && !hasPosted.current) {
                        props.setCursor(cursor);
                        track("scroll", { cursor: cursor });
                        hasPosted.current = true;
                    }
                }
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: 0.5,
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [props]);

    return (
        <div ref={ref} style={{ height: "100px" }}>
        </div>
    );
}
